import { Component } from "react";
import { BrowserRouter } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#050505] p-8 text-center text-white">
          <div>
            <p className="font-display text-2xl font-bold">HPNET</p>
            <p className="mt-2 text-white/60">
              Algo deu errado. Recarregue a página.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Home />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
